import { ProjectType } from "in_queue/types/projectType";
import { resolveProjectAssumption } from "../ScenarioDialog/projectAssumption";
import { ProjectSelection } from "./defaultProjectSelection";

/** Apply one project's new reduction to a selection, returning a new selection. */
export const applyProjectAssumptionChange = ({
    selection,
    projectId,
    projectType,
    eris,
    nris
}: {
    readonly selection: ProjectSelection;
    readonly projectId: string;
    readonly projectType: ProjectType;
    readonly eris: number;
    readonly nris: number;
}): ProjectSelection => {
    const action = resolveProjectAssumption({
        eris,
        nris,
        isSpeculative: projectType === ProjectType.SPECULATIVE_PROJECT
    });

    const projectSizeAssumptions = { ...selection.projectSizeAssumptions };
    if (action.assumption !== undefined) {
        projectSizeAssumptions[projectId] = action.assumption;
    } else {
        delete projectSizeAssumptions[projectId];
    }

    const includedSpeculativeProjectIds = action.includeInProjectAdditions
        ? Array.from(
              new Set([projectId, ...selection.includedSpeculativeProjectIds])
          )
        : selection.includedSpeculativeProjectIds.filter(
              (id) => id !== projectId
          );

    return { projectSizeAssumptions, includedSpeculativeProjectIds };
};
